export enum InboxReadStatus {
	UnreadOnly = 1,
	ReadOnly = 2,
}